<template>
    <div>
        <v-row>
            <v-col sm="12" md="11" class="">
                <div :class="{'max1000':true,'simple_search1': true,'active': borActive}">
                    <div class="left_icon hand" @click="openCountry">
                        <span class="icon"></span>
                        <span class="text hidden-sm-and-down">全球数据库</span>
                    </div>
                     <div class="input_box">
                        <v-combobox
                            v-model="model"
                            :items="items"
                            label="请输入搜索内容（例： 关键字、发明/设计人、专利号）"
                            :search-input.sync="search"
                            solo
                            clearable
                            light
                            hide-details
                            hide-selected
                            @keydown.enter="goResult"
                            @focus="borActive = true"
                            @blur="borActive = false"
                        >
                            <!-- @change="goResult" -->
                                 <template v-slot:no-data>
                                    <div class="search_history_box">
                                        <v-list-item key="-1">
                                        <v-list-item-content>
                                            <v-list-item-title>
                                            <div class="flex_style betw top_hist">
                                                <span class="text">历史记录</span>
                                                <span class="text1 hand" @click="goHistory">查看更多</span>
                                            </div>
                                            </v-list-item-title>
                                        </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item v-for="(item1,index1) in history1" :key="index1">
                                        <v-list-item-content>
                                            <v-list-item-title class="hand" @click="goResult1(item1)">
                                            {{item1}}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                        </v-list-item>
                                    </div>
                                </template>
                          
                        </v-combobox>
                        </div>
                        <div class="right_btn hand" @click="goResult">
                            <v-icon class="d-md-none">mdi-magnify</v-icon>
                            <span class="text hidden-sm-and-down">搜索</span>
                        </div>
                </div>  
                  
            </v-col>    
        </v-row>
        <v-dialog v-model="dialog" width="70%">
        <v-card class="country_dialog">
          <v-card-title class="headline lighten-2"> 搜索范围设定 </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <!-- <v-divider></v-divider> -->
            <h4 style="padding: 10px 0">全部数据库</h4>
            <v-list class="country_list">
              <v-checkbox
                  v-model="isAllCountry"
                  :indeterminate="isIndeter1"
                  label="全球数据库"
              >
              </v-checkbox>
              <v-list-item-group v-model="country" multiple color="primary">
                <v-list-item
                    v-for="(b, index) in cList"
                    :key="index"
                    :value="b.code"
                >
                  <template v-slot:default="{ active }">
                    <v-list-item-action>
                      <v-checkbox
                          :input-value="active"
                          color="primary"
                      ></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content :title="b.name">
                      <v-list-item-title>
                        <span :class="['flag', 'flag-' + b.code]"></span>
                        {{ b.name }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="dialog = false"> 取消 </v-btn>
            <v-btn color="primary" @click="saveCountry"> 保存 </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
</template>
<script>
import {countryData} from './country.js'
import { mapState, mapMutations, mapActions } from "vuex";
export default {
    name:'easyinput',
    data(){
        return{
             borActive: false,
             dialog:false,
             isAllCountry: false,
             cList:[],
             isIndeter1:false,
             country:[],
             //input
             model:'',
             items: [],
             history1:[],
             inputKey:'', 
             search: "",   
        }
    },
     watch: {
        isAllCountry(val) {
            if (val) {
                this.country = this.list;
            } else {
                this.country = [];
            }
        },
    
  },
  created(){
     this.getHistory()
  },
   methods:{
    ...mapActions("search", [
       "getHistoryList",
    ]),
    ...mapMutations("search", ["setSearchType", "setSearchKey"]),
       openCountry(){
           this.dialog = true;
           this.getCountrys();
            let country = localStorage.getItem("countries");
            if (country) {
                this.country =country && JSON.parse(country);
            } else {
                this.country = ['cn'];
            }
       },
       getCountrys() {
          this.cList=countryData
           
       },
        saveCountry() {
            let country = JSON.stringify(this.country);
            localStorage.setItem("countries", country);
            let types = JSON.stringify(this.types);
            localStorage.setItem("types", types);
            this.dialog = false;
    },
     //搜索
     goResult(){
   
        if (!this.search && !this.inputKey ) {
        this.$message({
          type: "info",
          message: "请输入关键词",
        });
        return false;
      }
     
      this.$router.push({
        path: "/search/result",
        query: {
          str: this.search || this.inputKey ||this.model ,
        },
      });
     },
    goResult1(val) {
      this.model = val;
      this.$router.push({
        path: "/search/result",
        query: {
          str: this.model,
        },
      });
      this.setSearchType(0);
      this.setSearchKey(this.model);
    },
    getHistory() {
      let _this = this;
      let data = {
        params: {
          page: 1,
          pageSize: 100,
        },
      };
      this.getHistoryList({
        data: data,
        handle(res) {

          let list = JSON.parse(res.message);
          console.log(list)
          list.forEach((item) => {
            if (_this.history1.indexOf(item.keywords) < 0) {
              _this.history1.push(item.keywords);
            }
          });
        },
      });
    },
     goHistory() {
      this.$router.push({
        path: "/user/history",
      });
    },
   },
  

}
</script>
<style scoped>

</style>